import { ITransactionState, ITransactionData } from '../interfaces/itransactions-filter';

export const TRANSACTION_STATE: ITransactionState = {
    transactions: <ITransactionData[]>[],
    enabled: true,
    total: 0
  };
